import React, { useState, useEffect } from "react";

// Media Query
import { useMediaQuery } from "react-responsive";
import { breakpoints } from "../../style/size";

// Style
import {
  NavigationDesktopWrapper,
  Content,
  TopContent,
  BottomContent,
  MenuWrapper,
  ResizeMenu,
  NavigationMobileWrapper,
  MobileContent,
  MobileListOverylay,
  MobileList,
  ContentMenu,
} from "../../style/Navigation";

import { LanguageSwitcher } from "../LanguageSwitcher/LanguageSwitcher";

// Language
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

// Images
import logo from "../../images/footerLogo.svg";
import logoWhite from "../../images/ic_logo_white.svg";
import smallLogo from "../../images/ic_logo_small.svg";
import smallLogoBlue from "../../images/ic_logo_small_blue.svg";
import resize from "../../images/ic_minimize.svg";
import resizeBlue from "../../images/ic_minimize_blue.svg";
import hamburgerMenu from "../../images/ic_menu.svg";
import close from "../../images/ic_close.svg";

// Menu Icons
import Home from "../../images/icons/home.svg";
import HomeBlue from "../../images/icons/home_blue.svg";
import HomeHover from "../../images/icons/home_hover.svg";
import HomeBlueHover from "../../images/icons/home_blue_hover.svg";
import HomeActive from "../../images/icons/home_active.svg";
import HomeBlueActive from "../../images/icons/home_blue_active.svg";

import SmrtSearch from "../../images/icons/smrtSearch.svg";
import SmrtSearchBlue from "../../images/icons/smrtSearch_blue.svg";
import SmrtSearchHover from "../../images/icons/smrtSearch_hover.svg";
import SmrtSearchBlueHover from "../../images/icons/smrtSearch_blue_hover.svg";
import SmrtSearchActive from "../../images/icons/smrtSearch_active.svg";
import SmrtSearchBlueActive from "../../images/icons/smrtSearch_blue_active.svg";
import compare from "../../images/ic_compare.svg";
import compareBlue from "../../images/compare_blue.svg";
import shadowTeamIconDark from "../../images/ic_formation.svg";
import shadowTeamIconLight from "../../images/formation_blue.svg";

import SmrtExplorerIcon from "../../images/icons/smrtExplorer.svg";
import SmrtExplorerBlue from "../../images/icons/smrtExplorer_blue.svg";
import SmrtExplorerHover from "../../images/icons/smrtExplorer_hover.svg";
import SmrtExplorerBlueHover from "../../images/icons/smrtExplorer_blue_hover.svg";
import SmrtExplorerActive from "../../images/icons/smrtExplorer_active.svg";
import SmrtExplorerBlueActive from "../../images/icons/smrtExplorer_blue_active.svg";

import FavoritesLinks from "../../images/icons/favoritesLinks.svg";
import FavoritesLinksBlue from "../../images/icons/favoritesLinks_blue.svg";
import FavoritesLinksHover from "../../images/icons/favoritesLinks_hover.svg";
import FavoritesLinksBlueHover from "../../images/icons/favoritesLinks_blue_hover.svg";
import FavoritesLinksActive from "../../images/icons/favoritesLinks_active.svg";
import FavoritesLinksBlueActive from "../../images/icons/favoritesLinks_blue_active.svg";

import MyPlaylists from "../../images/icons/myPlaylists.svg";
import MyPlaylistsBlue from "../../images/icons/myPlaylists_blue.svg";
import MyPlaylistsHover from "../../images/icons/myPlaylists_hover.svg";
import MyPlaylistsBlueHover from "../../images/icons/myPlaylists_blue_hover.svg";
import MyPlaylistsActive from "../../images/icons/myPlaylists_active.svg";
import MyPlaylistsBlueActive from "../../images/icons/myPlaylists_blue_active.svg";

import PlatformSetup from "../../images/icons/platformSetup.svg";
import PlatformSetupBlue from "../../images/icons/platformSetup_blue.svg";
import PlatformSetupHover from "../../images/icons/platformSetup_hover.svg";
import PlatformSetupBlueHover from "../../images/icons/platformSetup_hover_blue.svg";
import PlatformSetupActive from "../../images/icons/platformSetup_active.svg";
import PlatformSetupBlueActive from "../../images/icons/platformSetup_active_blue.svg";

import ContactUs from "../../images/icons/contactUs.svg";
import ContactUsBlue from "../../images/icons/contactUsBlue.svg";
import ContactUsHover from "../../images/icons/contactUs_hover.svg";
import ContactUsBlueHover from "../../images/icons/contactUs_blue_hover.svg";
import ContactUsActive from "../../images/icons/contactUs_active.svg";
import ContactUsBlueActive from "../../images/icons/contactUs_blue_active.svg";

import Logout from "../../images/icons/logout.svg";
import LogoutBlue from "../../images/icons/logout_blue.svg";
import LogoutHover from "../../images/icons/logout_hover.svg";
import LogoutBlueHover from "../../images/icons/logout_blue_hover.svg";
import LogoutActive from "../../images/icons/logout_hover.svg";
import LogoutBlueActive from "../../images/icons/logout_blue_hover.svg";

import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../store/user/userSlice";
import { checkAiAssistantAccess, checkSmrtExplorerAccess } from "../../store/user/userService";
import { useLexicon } from "../../hooks/useLexicon";
import { invalidateUserProfile } from "../../helpers/userProfile";

const Navigation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: `(${breakpoints.mobile})` });

  // Menu links
  const [activeRoute, setActiveRoute] = useState(null);
  const [hoveredRoute, setHoveredRoute] = useState(null);

  const [open, setOpen] = useState(JSON.parse(localStorage.getItem('navigationOpen')) ?? true);
  const [openMenu, setOpenMenu] = useState(false);

  const l = useLexicon();
  const smrtExplorerAllowed = useSelector(state => state.user.smrtExplorerAllowed);
  useEffect(() => {
    if (!localStorage.getItem("token")) return undefined;

    dispatch(checkSmrtExplorerAccess());
    dispatch(checkAiAssistantAccess());
  }, [dispatch]);

  useEffect(() => {
    const currentPath = window.location.pathname;
    setActiveRoute(currentPath);
  }, []);


  // Sync open state when other parts of the app toggle navigationOpen
  useEffect(() => {
    const handleNavigationOpenChange = () => {
      try {
        const value = JSON.parse(localStorage.getItem('navigationOpen')) ?? true;
        setOpen(value);
      } catch (_) {
        setOpen(true);
      }
    };
    window.addEventListener('navigationOpenChange', handleNavigationOpenChange);
    return () => {
      window.removeEventListener('navigationOpenChange', handleNavigationOpenChange);
    };
  }, []);

  function handleLogout() {
    localStorage.removeItem("token");
    invalidateUserProfile();
    dispatch(userActions.setToken(""));
    navigate("/login");
  }

  const menu = [
    {
      label: `${l(1032)}`,
      href: "/dashboard",
      icon: localStorage.getItem("theme") === "light" ? HomeBlue : Home,
      iconHover:
        localStorage.getItem("theme") === "light" ? HomeBlueHover : HomeHover,
      iconActive:
        localStorage.getItem("theme") === "light" ? HomeBlueActive : HomeActive,
    },
    {
      label: <>{l(1033)}</>,
      href: "/smrt-search",
      icon:
        localStorage.getItem("theme") === "light" ? SmrtSearchBlue : SmrtSearch,
      iconHover:
        localStorage.getItem("theme") === "light"
          ? SmrtSearchBlueHover
          : SmrtSearchHover,
      iconActive:
        localStorage.getItem("theme") === "light"
          ? SmrtSearchBlueActive
          : SmrtSearchActive,
    },
    ...(smrtExplorerAllowed === true ? [{
      label: "Smrt Explorer",
      href: "/smrt-explorer",
      icon:
        localStorage.getItem("theme") === "light" ? SmrtExplorerBlue : SmrtExplorerIcon,
      iconHover:
        localStorage.getItem("theme") === "light"
          ? SmrtExplorerBlueHover
          : SmrtExplorerHover,
      iconActive:
        localStorage.getItem("theme") === "light"
          ? SmrtExplorerBlueActive
          : SmrtExplorerActive,
    }] : []),
    {
      label: `${t("navigationDashboard.sequences")}`,
      href: "/sequence-search",
      icon:
        localStorage.getItem("theme") === "light" ? SmrtExplorerBlue : SmrtExplorerIcon,
      iconHover:
        localStorage.getItem("theme") === "light"
          ? SmrtExplorerBlueHover
          : SmrtExplorerHover,
      iconActive:
        localStorage.getItem("theme") === "light"
          ? SmrtExplorerBlueActive
          : SmrtExplorerActive,
    },
    {
      label: `${t("navigationDashboard.compare")}`,
      href: "/compare",
      icon:
        localStorage.getItem("theme") === "light"
          ? compareBlue
          : compare,
      iconHover: compareBlue,
      iconActive: compareBlue,
    },
    {
      label: `${t("navigationDashboard.shadowTeam")}`,
      href: "/shadow-team",
      icon:
        localStorage.getItem("theme") === "light"
          ? shadowTeamIconLight
          : shadowTeamIconDark,
      iconHover: shadowTeamIconLight,
      iconActive: shadowTeamIconLight,
    },
    {
      label: `${l(435)}`,
      href: "/favorites",
      icon:
        localStorage.getItem("theme") === "light"
          ? FavoritesLinksBlue
          : FavoritesLinks,
      iconHover:
        localStorage.getItem("theme") === "light"
          ? FavoritesLinksBlueHover
          : FavoritesLinksHover,
      iconActive:
        localStorage.getItem("theme") === "light"
          ? FavoritesLinksBlueActive
          : FavoritesLinksActive,
    },
    {
      label: `${l(124)}`,
      href: "/my-playlists",
      icon:
        localStorage.getItem("theme") === "light"
          ? MyPlaylistsBlue
          : MyPlaylists,
      iconHover:
        localStorage.getItem("theme") === "light"
          ? MyPlaylistsBlueHover
          : MyPlaylistsHover,
      iconActive:
        localStorage.getItem("theme") === "light"
          ? MyPlaylistsBlueActive
          : MyPlaylistsActive,
    },
    {
      label: `${l(1036)}`,
      href: "/platform-setup",
      icon:
        localStorage.getItem("theme") === "light"
          ? PlatformSetupBlue
          : PlatformSetup,
      iconHover:
        localStorage.getItem("theme") === "light"
          ? PlatformSetupBlueHover
          : PlatformSetupHover,
      iconActive:
        localStorage.getItem("theme") === "light"
          ? PlatformSetupBlueActive
          : PlatformSetupActive,
    },
  ];
  const bottomMenuItems = [
    {
      label: `${t("navigationDashboard.contactUs")}`,
      href: "/contact-us",
      icon:
        localStorage.getItem("theme") === "light" ? ContactUsBlue : ContactUs,
      iconHover:
        localStorage.getItem("theme") === "light"
          ? ContactUsBlueHover
          : ContactUsHover,
      iconActive:
        localStorage.getItem("theme") === "light"
          ? ContactUsBlueActive
          : ContactUsActive,
    },
    {
      label: `${l(1035)}`,
      href: "/login",
      icon: localStorage.getItem("theme") === "light" ? LogoutBlue : Logout,
      iconHover:
        localStorage.getItem("theme") === "light"
          ? LogoutBlueHover
          : LogoutHover,
      iconActive:
        localStorage.getItem("theme") === "light"
          ? LogoutBlueActive
          : LogoutActive,
      customClick: handleLogout,
    },
  ];

  const topMenu = menu.map((item, index) => {
    const Icon =
      activeRoute === item.href
        ? item.iconActive
        : hoveredRoute === item.href
          ? item.iconHover
          : item.icon;
    const isActive =
      activeRoute === item.href ? (open ? "active hideMenu" : "active") : undefined;
    return (
      <Link
        key={index}
        onMouseEnter={() => setHoveredRoute(item.href)}
        onMouseLeave={() => setHoveredRoute(null)}
        onClick={() => {
          setActiveRoute(item.href);
        }}
        to={item.href}
        className={isActive}
      >
        <img src={Icon} alt={item.label} />
        {open && item.label}
      </Link>
    );
  });

  const bottomMenu = bottomMenuItems.map((item, index) => {
    const Icon =
      activeRoute === item.href
        ? item.iconActive
        : hoveredRoute === item.href
          ? item.iconHover
          : item.icon;
    const isActive =
      activeRoute === item.href ? (open ? "active hideMenu" : "active") : undefined;
    return (
      <Link
        key={index}
        onMouseEnter={() => setHoveredRoute(item.href)}
        onMouseLeave={() => setHoveredRoute(null)}
        onClick={() => {
          setActiveRoute(item.href);
          item.customClick?.();
        }}
        to={item.href}
        className={isActive}
      >
        <img src={Icon} alt={item.label} />
        {open && item.label}
      </Link>
    );
  });

  const mobileMeni = [...menu, ...bottomMenuItems].map((item, index) => {
    const Icon =
      activeRoute === item.href
        ? item.iconActive
        : hoveredRoute === item.href
          ? item.iconHover
          : item.icon;
    const isActive = activeRoute === item.href ? "active" : "";
    return (
      <Link
        key={index}
        onMouseEnter={() => setHoveredRoute(item.href)}
        onMouseLeave={() => setHoveredRoute(null)}
        onClick={() => {
          setActiveRoute(item.href);
          item.customClick?.();
          setOpenMenu(false);
        }}
        to={item.href}
        className={isActive}
      >
        <img src={Icon} alt={item.label} />
        {item.label}
      </Link>
    );
  });

  let themeMode = localStorage.getItem("theme");

  const handleNavigationOpen = () => {
    setOpen(!open);
    localStorage.setItem("navigationOpen", open ? false : true)
    window.dispatchEvent(new Event("navigationOpenChange"));
  }

  const desktopNavigation = (
    <NavigationDesktopWrapper $hide={!open}>
      <Content $hide={!open}>
        <TopContent>
          {!open ? (
            <img className="smallLogo" src={localStorage.getItem("theme") === "light" ? smallLogoBlue : smallLogo} alt={smallLogo} />
          ) : (
            <img
              className="logo"
              src={themeMode === "light" ? logoWhite : logo}
              alt={logo}
            />
          )}

          <MenuWrapper>{topMenu}</MenuWrapper>
        </TopContent>
        <BottomContent>
          <LanguageSwitcher menuIsOpen={open} containerStyle={{ marginLeft: open ? 5 : 0, position: 'static' }} />
          <MenuWrapper>{bottomMenu}</MenuWrapper>
        </BottomContent>
      </Content>

      <ResizeMenu onClick={handleNavigationOpen}>
        <img src={localStorage.getItem("theme") === "light" ? resizeBlue : resize} alt={resize} />
      </ResizeMenu>
    </NavigationDesktopWrapper>
  );

  const mobileNavigation = (
    <>
      <NavigationMobileWrapper>
        <MobileContent>
          <img className="mobileLogo" src={localStorage.getItem("theme") === "light" ? logoWhite : logo} alt={logo} />
          <LanguageSwitcher />
          {!openMenu ? (
            <img
              src={hamburgerMenu}
              alt={hamburgerMenu}
              onClick={() => setOpenMenu(!openMenu)}
            />
          ) : (
            <img
              src={close}
              alt={close}
              onClick={() => setOpenMenu(!openMenu)}
            />
          )}
        </MobileContent>
      </NavigationMobileWrapper>
      {openMenu && (
        <MobileListOverylay>
          <MobileList>
            <ContentMenu>{mobileMeni}</ContentMenu>
          </MobileList>
        </MobileListOverylay>
      )}
    </>
  );

  return <>{isMobile ? mobileNavigation : desktopNavigation}</>;
};

export default Navigation;
